import { Menu as MenuIcon } from "@mui/icons-material";
import {
  AppBar,
  Drawer,
  Grid,
  Grid2,
  IconButton,
  Paper,
  Theme,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC, useEffect, useState } from "react";
import { DrawerContent } from "./drawer";
import { Outlet, useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.getElementById("root")?.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
}

export const Layout: FC = () => {
  const [isDrawerOpen, drawerToggle] = useState(false);

  const classes = useClass();

  return (
    <Grid
      container
      height="100%"
      justifyContent="space-between"
      alignItems="stretch"
    >
      <Drawer
        anchor={"left"}
        open={isDrawerOpen}
        onClose={() => drawerToggle((pre) => !pre)}
      >
        <Grid2 className={classes.mobileDrawerContainer}>
          <DrawerContent close={() => drawerToggle(false)} />
        </Grid2>
      </Drawer>
      <ScrollToTop />
      <Paper component={Grid} item className={classes.desktopDrawerContainer}>
        <Grid2 className={classes.drawerContent}>
          <DrawerContent close={() => drawerToggle(false)} />
        </Grid2>
      </Paper>
      <Grid item container flex={1} direction="column">
        <AppBar position="relative" className={classes.appBar}>
          <Toolbar component={Grid2} container>
            <Grid item>
              <>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  className={classes.menuIcon}
                  onClick={() => drawerToggle((pre) => !pre)}
                >
                  <MenuIcon color="action" />
                </IconButton>
                <Typography
                  variant="h6"
                  component="span"
                  sx={{ flexGrow: 1 }}
                ></Typography>
              </>
            </Grid>
            <Grid item>
              <Typography>Tenoto</Typography>
            </Grid>
          </Toolbar>
        </AppBar>
        <Grid2 container flex={1}>
          <Outlet />
        </Grid2>
      </Grid>
    </Grid>
  );
};

const useClass = makeStyles((theme: Theme) => ({
  desktopDrawerContainer: {
    width: 280,
    [theme.breakpoints.down("lg")]: {
      display: "none",
    },
  },
  drawerContent: {
    position: "fixed",
    left: 0,
    top: 0,
    bottom: 0,
    width: 280,
  },
  mobileDrawerContainer: {
    width: 280,
  },
  menuIcon: {
    display: "none !important",
    [theme.breakpoints.down("lg")]: {
      display: "inline-flex !important",
      marginLeft: `${theme.spacing(0.1)} !important`,
    },
  },
  appBar: {
    height: 68,
    justifyContent: "center",
  },
}));
